import { render, staticRenderFns } from "./studylevellog.vue?vue&type=template&id=bbaabd22&"
import script from "./studylevellog.vue?vue&type=script&lang=js&"
export * from "./studylevellog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports